import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'lead-emagrecimento',
    title: 'Lead qualificado — Programa de emagrecimento',
    description: 'Qualifique candidatos para o seu programa de emagrecimento com perguntas sobre histórico e comprometimento.',
    indicatedFor: 'Nutricionistas',
    stepsCount: 1,
    questionsSummary: ['Nome e contato', 'Histórico de peso', 'Tentativas anteriores', 'Nível de comprometimento'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Programa de emagrecimento — candidatura',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Sua candidatura',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar candidatura',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: 'Nome completo',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'email',
                        label: 'Melhor e-mail',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'phone',
                        label: 'WhatsApp',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'weight',
                        label: 'Qual é o seu peso atual?',
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 5,
                        type: 'text',
                        label: 'Qual é o peso que você deseja atingir e em quanto tempo?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 6,
                        type: 'yes_no_maybe',
                        label: 'Você já tentou emagrecer antes sem resultado duradouro?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 7,
                        type: 'scale',
                        label: 'O quanto você está disposto a mudar seus hábitos agora?',
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: 'Ainda hesitante',
                            maxLabel: 'Totalmente comprometido',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                ],
            },
        ],
        actions: [],
    },
};
